import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { MenuController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: UserService, private router: Router, private menuCtrl: MenuController, private authPermissions: UserService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    let isLogged = await this.authService.isLogged();
    if (isLogged) {
      this.menuCtrl.enable(true);
      const permissions = route.data['permissions'] as string[];
      //every
      // console.log("ENTRAAA", permissions);

      if (permissions && !permissions.some(permission => this.authPermissions.hasPermission(permission))) {
        return false;
      }
      return true;
    }
    return false;
  }
}
